require('./mortgageRequestManagerPanelSteps.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { formatText, getLanguage, FormattedText } = require('core/i18n').i18n;
const contains = require('lodash/collection/contains');

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');

// @ utils
const UrlHelper = require('utilities/urlHelper');

// @ components
const {
    MortgageRequestDataProprietor
} = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestDataProprietor/mortgageRequestDataProprietor');
const {
    MortgageRequestManagerPanelLivingPlace
} = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerPanelLivingPlace/mortgageRequestManagerPanelLivingPlace');
const {
    MortgageRequestManagerPanelInsurancesRelated
} = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerPanelInsurancesRelated/mortgageRequestManagerPanelInsurancesRelated');
const {
    MortgageRequestManagerPanelSignature
} = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerPanelSignature/mortgageRequestManagerPanelSignature');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ actions
const { resetInmuebles } = require('actions/mortgageRequest/mortgageRequestInmuebles');
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const mortgageRequestConditionsActions = require('actions/mortgageRequest/mortgageRequestConditions');
const simpleNoteActions = require('actions/mortgageRequest/mortgageRequestSimpleNote');
const { okInsuranceActions: { insuranceRequestRelatedState, insuranceRequestRelatedRNCState } } = require('ok-insurance');
const getHolderConfirmActions = require('actions/mortgageRequest/mortgageRequestHolderConfirmation');

// @ constants
const mortgageRequestPanelStates = require('constants/mortgageRequestPanelStates');
const { buildPanelStepsFormated, buildPanelStepsConditionsText, buildPanelStepsLanguage } = require('./buildMortgagePanelSteps')
const { MORTGAGE_TYPE_TEXT } = require('constants/mortgageRequestMortgageDataTypes');
const { MORTGAGE_TYPE } = require('constants/mortgageRequestType')

class MortgageRequestManagerPanelSteps extends React.Component {
    constructor(props) {
        super(props);

        const { mortgageRequestState } = this.props;
        this.dataPropietorComponent = React.createRef();
        this.currentCaseId = mortgageRequestState.get('idExpediente');
        this.currentState = mortgageRequestState.get('estado');
        this.isExpandedDataProprietor = contains(
            mortgageRequestPanelStates.CURRENT_STATES_DATA_PROPRIETOR,
            this.currentState
        );
        this.isExpandedLivingPlace = contains(
            mortgageRequestPanelStates.CURRENT_STATES_LIVING_PLACE,
            this.currentState
        );
        this.isExpandedSignature = contains(
            mortgageRequestPanelStates.CURRENT_STATES_SIGNATURE,
            this.currentState
        );

        this.isApprovedDataProprietor = !contains(
            mortgageRequestPanelStates.APPROVED_STATES_DATA_PROPRIETOR,
            this.currentState
        );
        this.isApprovedLivingPlace = !contains(
            mortgageRequestPanelStates.APPROVED_STATES_LIVING_PLACE,
            this.currentState
        );
        this.isApprovedSignature = !contains(
            mortgageRequestPanelStates.APPROVED_STATES_SIGNATURE,
            this.currentState
        );

        this.buildLoading = this.buildLoading.bind(this);
        this.buildPanelSteps = this.buildPanelSteps.bind(this);
    }

    componentDidMount() {
        const {
            checkHolderPersonalInfo,
            requestSummaryDocumentation,
            requestDataProprietor,
            requestConditions,
            fetchEstatesData,
            getInsuranceState,
            getInsuranceRNCState,
            immGlobalPosition
        } = this.props;
        if (this.currentCaseId) {
            requestDataProprietor();
            fetchEstatesData();
            requestSummaryDocumentation(this.currentCaseId);
            requestConditions();
            immGlobalPosition.get("isClientWithoutAccounts") ? getInsuranceRNCState(false, this.currentCaseId) : getInsuranceState(false, this.currentCaseId);
            checkHolderPersonalInfo();
        }

        if (this.dataPropietorComponent.current) {
            this.scrollToComponent();

            this.dataPropietorComponent
                .current
                .isReady()
                .then(this.scrollToComponent.bind(this));
        }
    }

    componentWillUnmount() {
        this.props.resetInmuebles();
    }

    buildLoading() {
        return (
            <div className="row step-item">
                <LoadingSection />
            </div>
        );
    }

    buildPanelSteps() {
        const {
            panelTitleFinalInfo,
            mortgageRequestConditionsState,
            mortgageRequestMortgageData,
            flagBasedFeatures,
            immHolderConfirmState,
            insuranceRelatedState,
            getInsuranceRNCState,
            dataProprietor,
            immProfile,
            immGlobalPosition
        } = this.props;

        const panelTitleFinalInfoWrapper = panelTitleFinalInfo.set('cuotaMensual',
            mortgageRequestConditionsState.getIn(['conditions', 'cuotaMensual']));
        const propsConditionsText = {
            mortgageRequestConditionsState: mortgageRequestConditionsState,
            panelTitleFinalInfo: panelTitleFinalInfoWrapper
        };
        const conditionsText = buildPanelStepsConditionsText(propsConditionsText);
        const currencyFormat = buildPanelStepsFormated(panelTitleFinalInfoWrapper);
        const propsHandlerTitle = {
            lenguage: getLanguage(),
            mortgageTypeText: conditionsText.mortgageTypeText,
            totalFormatted: currencyFormat.totalFormatted,
            panelTitleFinalInfo: panelTitleFinalInfoWrapper.get('plazo')
        };
        const buildLanguage = buildPanelStepsLanguage(propsHandlerTitle);
        const mortgageTae = conditionsText.mortgageTypeText === MORTGAGE_TYPE_TEXT.FIJA ? 'subtitlePanel2Fixed' : 'subtitlePanel2';
        const panelText = formatText(`mortgageRequestPanel-${mortgageTae}`, [conditionsText.tinText, conditionsText.taeVariable]);
        const index = panelText.lastIndexOf('(');
        const firstText = panelText.substring(0, index);
        const lastText = panelText.substring(index);

        const homeInsuranceEnabled = flagBasedFeatures.get('mortgage-home-insurance-enabled');
        const stepNumManagerPanelSignature = homeInsuranceEnabled ? 4 : 3;
        const hasInsurance = mortgageRequestConditionsState.getIn(['conditions', 'incluyeSeguroHogar']);
        const userDocumentNumber = immProfile.getIn(['documentoIdentificacion', 'codigodocumpersonacorp']);
        const isFetchingDataProprietor = dataProprietor.get('isFetching');
        const accountHolderObj = dataProprietor.get('data').filter((account) => {
            const accID =  account.getIn(['datosPersonales','documentoDeIdentidad','identificador']);
            return accID === userDocumentNumber;
        });
        const accountHolder =  accountHolderObj.getIn(['0','numeroTitular']);
        const insurancesRelatedStep = homeInsuranceEnabled && (
            <MortgageRequestManagerPanelInsurancesRelated
                flagBasedFeatures={flagBasedFeatures}
                hasInsurance={hasInsurance}
                accountHolder={accountHolder}
                isFetching={isFetchingDataProprietor}
                insuranceRelatedState={insuranceRelatedState}
                isClientWithoutAccounts={immGlobalPosition.get("isClientWithoutAccounts")}
                currentCaseId={this.currentCaseId}
                getInsuranceRNCState={getInsuranceRNCState}
            />
        )

        return (
            <div>
                <div className="mortgage-request-manager-panel-buttons">
                    <OKLink modifier="complementary" id={'btnStepsModify'} to={'/myprofile/mortgage/mortgage-edit'}>
                        {formatText('mortgageRequestPanel-modify')}
                    </OKLink>
                    <OKBoxTitle
                        value={buildLanguage}
                        size="medium" isNotSeparator={true}>
                        <strong>{formatText('mortgageRequestPanel-subtitlePanel1')} {currencyFormat.monthlyFormatted} </strong>
                        <span>{firstText}<strong>{lastText}</strong></span>
                    </OKBoxTitle>
                </div>
                <div className="mortgage-request-manager-panel-steps">
                    <MortgageRequestDataProprietor
                        isExpandedDataProprietor={this.isExpandedDataProprietor}
                        isApprovedDataProprietor={this.isApprovedDataProprietor}
                        wrappedComponentRef={this.dataPropietorComponent}
                        currentState={this.currentState}
                        isClientWithoutAccounts={immGlobalPosition.get("isClientWithoutAccounts")}
                        immHolderConfirmState={immHolderConfirmState}
                    />
                    <MortgageRequestManagerPanelLivingPlace
                        isExpandedLivingPlace={this.isExpandedLivingPlace}
                        isApprovedLivingPlace={this.isApprovedLivingPlace}
                    />
                    {insurancesRelatedStep}
                    <MortgageRequestManagerPanelSignature
                        isExpandedSignature={this.isExpandedSignature}
                        isApprovedSignature={this.isApprovedSignature}
                        ref={child => {
                            this.managerPanelSignatureComponent = child;
                        }}
                        currentState={this.currentState}
                        mortgageRequestMortgageData={mortgageRequestMortgageData}
                        stepNum={stepNumManagerPanelSignature}
                    />
                </div>
            </div>
        );
    }

    scrollToComponent() {
        let hash = location.hash.replace('#', '').toLowerCase();

        if (hash && hash === 'step-3') {
            UrlHelper.scrollTo(this.managerPanelSignatureComponent);
        }
    }

    render() {
        const {
            panelTitleFinalInfo,
            summaryDocumentation,
            dataProprietor,
            mortgageRequestConditionsState,
            estatesStateData,
            mortgageRequestMortgageData,
            insuranceRelatedState,
        } = this.props;
        const variableType= mortgageRequestMortgageData.getIn(['data','tipoProducto'])
        const isFetchedSummaryDocumentation = summaryDocumentation.get('documentsRequested');
        const isFetchedDataProprietor = dataProprietor.get('hasBeenFetched');
        const isFetchedEstatesStateData = estatesStateData.get('dataPanelRequested');
        const isFetchingPanelTitleFinalInfo = panelTitleFinalInfo.get('isFetching');
        const isFetchingMortgageRequestConditionsState = mortgageRequestConditionsState.get(
            'isFetching'
        );
        const isFetchingMortgageData = mortgageRequestMortgageData.get('isFetching');
        const isFetchingInsuranceRelatedState = insuranceRelatedState.get('isFetching')
        let contentPanelSteps;

        if (
            isFetchingPanelTitleFinalInfo ||
            isFetchingMortgageRequestConditionsState ||
            (this.isExpandedDataProprietor && !isFetchedDataProprietor) ||
            ((this.isExpandedDataProprietor || this.isExpandedLivingPlace) &&
                (!isFetchedSummaryDocumentation || !isFetchedEstatesStateData)) ||
            isFetchingMortgageData ||
            isFetchingInsuranceRelatedState
        ) {
            contentPanelSteps = this.buildLoading();
        } else {
            contentPanelSteps = this.buildPanelSteps();
        }

        return (
            <ContentBox>
                {contentPanelSteps}
                <br />
                <p>
                    <FormattedText value="mortgageRequestPanel-mortgageRequestPanel_footerDisclaimer" />
                </p>
                {variableType !== MORTGAGE_TYPE.FIJO && 
                <p>
                {formatText('mortgageRequestMortgageEdit-mortgageModifyLegalText')}
                </p>
                }  
            </ContentBox>
        );
    }
}

MortgageRequestManagerPanelSteps.propTypes = {
    mortgageRequestConditionsState: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    panelTitleFinalInfo: PropTypes.object,
    summaryDocumentation: PropTypes.object,
    dataProprietor: PropTypes.object,
    estatesStateData: PropTypes.object,
    requestSummaryDocumentation: PropTypes.func,
    requestDataProprietor: PropTypes.func,
    getPanelTitleInfo: PropTypes.func,
    requestConditions: PropTypes.func,
    fetchEstatesData: PropTypes.func,
    resetInmuebles: PropTypes.func,
    mortgageRequestMortgageData: PropTypes.object,
    getInsuranceState: PropTypes.func,
    getInsuranceRNCState: PropTypes.func,
    isClientWithoutAccounts: PropTypes.bool,
    flagBasedFeatures: PropTypes.object,
    checkHolderPersonalInfo: PropTypes.func,
    immHolderConfirmState: PropTypes.object,
    insuranceRelatedState: PropTypes.object,
    immProfile: PropTypes.object,
    immGlobalPosition: PropTypes.object,
};

module.exports.constructor = MortgageRequestManagerPanelSteps;
module.exports.MortgageRequestManagerPanelSteps = connect(
    state => ({
        mortgageRequestState: state.mortgageRequestState,
        panelTitleFinalInfo: state.mortgageRequestPanelTitle,
        summaryDocumentation: state.mortgageRequestSummaryDocumentation,
        dataProprietor: state.mortgageRequestDataProprietor,
        mortgageRequestConditionsState: state.mortgageRequestConditions,
        estatesStateData: state.mortgageRequestEstatesData,
        mortgageRequestMortgageData: state.mortgageRequestMortgageData,
        flagBasedFeatures: state.flagBasedFeatures,
        immHolderConfirmState: state.mortgageRequestHolderConfirmEdit,
        insuranceRelatedState: state.insuranceRequestRelatedState,
        immProfile: state.profile,
        immGlobalPosition:state.globalPosition,
    }),
    {
        requestConditions: mortgageRequestConditionsActions.requestConditions,
        requestSummaryDocumentation: dataProprietorActions.requestSummaryDocumentation,
        requestDataProprietor: dataProprietorActions.requestDataProprietor,
        fetchEstatesData: simpleNoteActions.fetchEstatesData,
        resetInmuebles: resetInmuebles,
        getInsuranceState: insuranceRequestRelatedState.requestInsuranceRelatedCurrentState,
        getInsuranceRNCState: insuranceRequestRelatedRNCState.requestInsuranceRelatedRNCCurrentState,
        checkHolderPersonalInfo: getHolderConfirmActions.holderCheckPersonalInfo
    }
)(MortgageRequestManagerPanelSteps);
